var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef, EventEmitter } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../base.component';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';
import { ResizeImageModalActions, ResizeImageModalData, } from '../../../components/hub/resize.image.modal/resize.image.modal.provider';
import { ResizeImageModalComponent } from '../../../components/hub/resize.image.modal/resize.image.modal.component';
import { ModalService } from '../../services/modal.service';
var ImageResizeComponent = /** @class */ (function (_super) {
    __extends(ImageResizeComponent, _super);
    function ImageResizeComponent(modalService, imageService) {
        var _this = _super.call(this) || this;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.onImageResized = new EventEmitter();
        return _this;
    }
    ImageResizeComponent.prototype.ngOnInit = function () { };
    ImageResizeComponent.prototype.resizeImage = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var actions, _a, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if ($event) {
                            $event.stopPropagation();
                            $event.preventDefault();
                        }
                        actions = {
                            confirm: function (event, image) {
                                // !!image && (this.resizeImageTemp = image);
                                _this.onImageResized.emit(image);
                            },
                        };
                        if (!(typeof this.imageToResize !== 'string')) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.imageToResize, config.compressImgWidth)];
                    case 1:
                        _a.resizeImageTemp = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.resizeImageTemp = this.imageToResize;
                        _b.label = 3;
                    case 3:
                        data = {
                            data: this.resizeImageTemp,
                        };
                        this.modalService.show({
                            component: ResizeImageModalComponent,
                            providers: [
                                { provide: ResizeImageModalActions, useValue: actions },
                                { provide: ResizeImageModalData, useValue: data },
                            ],
                            panelClass: 'width-modal-2',
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return ImageResizeComponent;
}(BaseComponent));
export { ImageResizeComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/image.rezise/image.resize.component.ts.pre-build-optimizer.js